import { Language } from '../../../../lib/Localized';
import { VehicleLicensePlateType } from '../../../models/Vehicle';

export function languageTranslations(language: Language) {
    switch (language) {
        case Language.DE:
            return {
                de: 'Deutsch',
                fr: 'Allemande',
                it: 'Tedesco',
                en: 'German',
            };
        case Language.FR:
            return {
                de: 'Französisch',
                fr: 'Français',
                it: 'Francese',
                en: 'French',
            };
        case Language.IT:
            return {
                de: 'Italienisch',
                fr: 'Italienne',
                it: 'Italiano',
                en: 'Italian',
            };
        case Language.EN:
            return {
                de: 'Englisch',
                fr: 'Anglaise',
                it: 'Inglese',
                en: 'English',
            };
    }
}

export const languageOptions = [
    {
        translations: languageTranslations(Language.DE),
        value: Language.DE,
    },
    {
        translations: languageTranslations(Language.FR),
        value: Language.FR,
    },
    {
        translations: languageTranslations(Language.IT),
        value: Language.IT,
    },
    {
        translations: languageTranslations(Language.EN),
        value: Language.EN,
    },
];

export const licensePlateOptions = (lang: Language) =>
    Object.values(VehicleLicensePlateType).map(type => ({
        display: {
            [VehicleLicensePlateType.CAR]: {
                [Language.DE]: 'Auto',
                [Language.FR]: 'Auto',
                [Language.IT]: 'Auto',
                [Language.EN]: 'Car',
            },
            [VehicleLicensePlateType.MOTORCYCLE]: {
                [Language.DE]: 'Motorrad',
                [Language.FR]: 'Moto',
                [Language.IT]: 'Motocicletta',
                [Language.EN]: 'Motorcycle',
            },
        }[type][lang],
        value: type,
    }));
